import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { PortfolioPage } from './pages/PortfolioPage';
import { PortfolioRedirect } from './pages/PortfolioRedirect';
import { HowWeInvestPage } from './pages/HowWeInvestPage';
import { HowWeHelpPage } from './pages/HowWeHelpPage';
import { TeamPage } from './pages/TeamPage';
import { TeamMemberPage } from './pages/TeamMemberPage';
import { BlogPage } from './pages/BlogPage';
import { BlogPostPage } from './pages/BlogPostPage';
import { InsightsPage } from './pages/InsightsPage';
import { ContactPage } from './pages/ContactPage';
import { ThemeProvider } from './contexts/ThemeContext';
import { PasswordProtect } from './components/PasswordProtect';
import { GoogleAnalytics } from './components/GoogleAnalytics';
export function App() {
  return <ThemeProvider data-id="element-0">
      <BrowserRouter data-id="element-1">
        <GoogleAnalytics data-id="element-2" />
        <div className="flex flex-col min-h-screen bg-white text-[#070707] transition-colors" data-id="element-3">
          <Navbar data-id="element-4" />
          <main className="flex-grow" data-id="element-5">
            <Routes data-id="element-6">
              <Route path="/" element={<HomePage data-id="element-8" />} data-id="element-7" />
              <Route path="/home" element={<Navigate to="/" replace data-id="element-10" />} data-id="element-9" />
              <Route path="/companies" element={<PortfolioPage data-id="element-12" />} data-id="element-11" />
              <Route path="/portfolio" element={<Navigate to="/companies" replace data-id="element-14" />} data-id="element-13" />
              <Route path="/portfolio/:slug" element={<PortfolioRedirect data-id="element-16" />} data-id="element-15" />
              <Route path="/how-we-invest" element={<HowWeInvestPage data-id="element-18" />} data-id="element-17" />
              <Route path="/how-we-help" element={<HowWeHelpPage data-id="element-20" />} data-id="element-19" />
              <Route path="/team" element={<TeamPage data-id="element-22" />} data-id="element-21" />
              <Route path="/team/:slug" element={<TeamMemberPage data-id="element-24" />} data-id="element-23" />
              <Route path="/blog" element={<BlogPage data-id="element-26" />} data-id="element-25" />
              <Route path="/blog/:slug" element={<BlogPostPage data-id="element-28" />} data-id="element-27" />

              {/* Password Protected Staging Blog */}
              <Route path="/staging-blog" element={<PasswordProtect data-id="element-30">
                    <BlogPage basePath="/staging-blog" data-id="element-31" />
                  </PasswordProtect>} data-id="element-29" />
              <Route path="/staging-blog/:slug" element={<PasswordProtect data-id="element-33">
                    <BlogPostPage basePath="/staging-blog" data-id="element-34" />
                  </PasswordProtect>} data-id="element-32" />

              <Route path="/insights" element={<InsightsPage data-id="element-36" />} data-id="element-35" />
              <Route path="/contact" element={<ContactPage data-id="element-38" />} data-id="element-37" />
              <Route path="/contactus" element={<Navigate to="/contact" replace data-id="element-40" />} data-id="element-39" />
            </Routes>
          </main>
          <Footer data-id="element-41" />
        </div>
      </BrowserRouter>
    </ThemeProvider>;
}